import React from "react";
import emoji from "react-easy-emoji";

const Footer = () => {
  return <div className="footer">Made by humanbeeng ❤️</div>;
};

export default Footer;
